import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    // height: '100vh',
    position: 'relative',
    overflowY: 'hidden',
    // justifyContent: 'space-between'
    height: 'calc(var(--vh, 1vh) * 100)'
  },
  main: {
    display: 'flex',
    flexDirection: 'row'
  },
  joiningRoot: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh'
  },
  sidebar: {
    padding: theme.spacing(2.5),
    overflowY: 'auto',
    height: '90vh'
  },
  bottombar: {
    padding: theme.spacing(2.5),
    paddingTop: 0,
    paddingInlineEnd: 0
  },
  bottombarLandscape: {
    paddingTop: 0,
    display: 'flex',
    backgroundColor: '#ffffff'
  },
  participants: {
    overflowX: 'auto',
    display: 'flex'
  },
  details: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  detailResponsive: {
    width: '70%'
  },
  materialsContainer: {
    display: 'flex',
    flex: '1',
    // height: 'calc(100vh - 81px)'
    height: '90vh'
  },
  materialsContainerResponsive: {
    display: 'flex',
    flex: '1',
    height: 'auto',
    justifyContent: 'center'
  },
  bookingInfoWrapper: {},
  divider: {
    marginTop: theme.spacing(2.5)
  },
  tip: {
    marginBottom: theme.spacing(2.5),
    maxWidth: 310
  },
  landscapView: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#ffffff',
    position: 'absolute',
    bottom: 0,
    width: '100%',
    overflowX: 'scroll'
  },
  controls: {},
  audioContent: {
    padding: '2%',
    maxWidth: '310px',
    overflowY: 'auto',
    backgroundColor: theme.palette.background.paper,
    borderRadius: 10,
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
    margin: '5px 0px',
    maxHeight: '250px',
    height: '100%',
    OverflowY: 'scroll',
    scrollbarWidth: 'thin',
    flexGrow: 1,
    '@media (max-width: 900px)': {
      maxHeight: '160px',
      margin: '5px'
    }
  },
  '@global': {
    '@keyframes fadeIn': {
      '0%': {
        opacity: 0,
        transform: 'translateY(-10px)'
      },
      '100%': {
        opacity: 1,
        transform: 'translateY(0)'
      }
    }
  }
}));
